import { CommonState } from 'embed/reducers'

export const isLoggedInSelector = (state: CommonState): boolean => state.auth.isLoggedIn
